import { render, staticRenderFns } from "./IncidentReportHeaderBox.vue?vue&type=template&id=01ed9e70&"
import script from "./IncidentReportHeaderBox.vue?vue&type=script&lang=js&"
export * from "./IncidentReportHeaderBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports